import { DateParam, NumberParam, StringParam } from "use-query-params";
import { ListModel } from "../models/list-model";

// search params config
export const queryParamsConfig = {
  page: NumberParam,
  pageSize: NumberParam,
  search: StringParam,
  mesAno: DateParam,
  estado: StringParam,
  profesionalId: StringParam,
  sortDirection: NumberParam,
  sortColumn: StringParam,
};

export const initialFilter = {
  page: 1,
  pageSize: 15,
};

export const formatearEstado = (estado: string) => {
  switch (estado) {
    case "PENDIENTE":
      return "Pendiente";
    case "ENVIADA":
      return "Enviada";
    case "LIQUIDADA":
      return "Liquidada";
    case "PAGADA":
      return "Pagada";
    case "RECHAZADA":
      return "Rechazada";
    default:
      return "";
  }
};

export const formatPracticaDescription = (
  numero: string,
  descripcion: string
) => {
  var nombre = "";
  if (numero !== "") nombre = numero;

  if (nombre !== "" && descripcion !== "")
    nombre = nombre + " - " + descripcion;

  if (nombre === "" && descripcion !== "") nombre = descripcion;

  return nombre;
};

export const ListaEstados: ListModel[] = [
  {
    value: "PENDIENTE",
    label: "Pendiente",
  },
  {
    value: "ENVIADA",
    label: "Enviada",
  },
  {
    value: "LIQUIDADA",
    label: "Liquidada",
  },
  {
    value: "PAGADA",
    label: "Pagada",
  },
  {
    value: "RECHAZADA",
    label: "Rechazada",
  },
];
